/* Marinelie — Shop All: eine Geste, ein Schirm.

   Das Einrasten per CSS (scroll-snap-stop: always) haelt den Browser
   beim Wischen an jedem Bild an — beim Mausrad und beim Trackpad aber
   nicht: ein kraeftiger Stoss traegt ueber mehrere Bilder hinweg.
   Otton (13.09.2026): "wenn ich stark genug scrolle, scrolle ich komplett
   durch alle durch. bei byredo ist da eine blockade, man kann immer nur
   einen slide nach unten."

   Also uebernimmt dieses Skript das Rad: Solange die Sicht im Feed
   steht, wird jede Rad-Geste abgefangen und faehrt genau ein Bild weiter
   oder zurueck. Eine Geste ist die Folge von Rad-Ereignissen, zwischen
   denen weniger als 180 ms liegen — so zaehlt das Nachrollen des
   Trackpads noch zur selben Geste und loest kein zweites Bild aus.
   Am letzten Bild nach unten und am ersten nach oben laeuft das Rad
   wieder nativ, sonst kaeme man nicht zur Fusszeile.

   Fingerwischen auf dem Telefon bleibt beim CSS-Einrasten, das haelt
   dort schon an jedem Bild. */
(function () {
  'use strict';

  var feed = document.querySelector('[data-shopfeed]');
  if (!feed) return;

  var schirme = Array.prototype.slice.call(feed.querySelectorAll('.ml-sf__schirm'));

  /* ----------------------------------------------------------------
     Die Hoehe eines Schirms — gemessen, nicht geraten.

     Im Stylesheet stand bisher 100svh minus `--header-height`. Diese
     Variable setzt Dawns Kopfzeile einmal beim Laden und danach nur
     noch, wenn die 990px-Grenze faellt. Aendert sich die Kopfzeile
     sonstwie — Fenster schmaler gezogen, Logo erst mit der Schrift
     fertig, eine Leiste ueber dem Kopf —, bleibt der alte Wert stehen.
     Dann ist der Schirm zu hoch und die Fusszeile mit dem Preis liegt
     unter der Kante; im ersten Bild fehlt genau das, was klickbar
     machen soll. Otton am 19.09.2026: "ich will text bisschen besser
     platzieren, damit es nur im ersten frame auf jeden fall passt."

     Also wird gemessen, was wirklich dasteht:

       --ml-sf-kopf  Hoehe der klebenden Kopfzeile. Sie ueberdeckt die
                     Schirme 2..n und gibt damit die Rastkante.
       --ml-sf-oben  Abstand des Feeds vom Seitenanfang, also alles, was
                     im Fluss ueber ihm liegt. Daran haengt der erste
                     Schirm.

     Gemessen wird beim Start, nach dem Laden, wenn die Schriften stehen,
     bei jeder Groessenaenderung und wenn die Kopfzeile selbst ihre Hoehe
     aendert. Geschrieben wird nur, was sich wirklich bewegt hat — sonst
     liefe bei jedem Rahmen ein Stilwechsel durch die ganze Seite.
     ---------------------------------------------------------------- */
  var kopfzeile = document.querySelector('.section-header');
  var gemessen = { kopf: -1, oben: -1 };
  var messWartet = false;

  function messen() {
    messWartet = false;

    /* Hoehe der Kopfrille fuer die feste Kopfzeile (siehe CSS). */
    var rille = document.querySelector('.rille-01');
    if (rille) document.documentElement.style.setProperty('--ml-rille-h', Math.round(rille.getBoundingClientRect().height) + 'px');

    /* Liegt die Kopfzeile fest auf dem Bild (Shop All, 06.10.), nimmt
       sie dem Schirm keine Hoehe weg: dann zaehlt sie null. */
    var kopfLage = kopfzeile ? window.getComputedStyle(kopfzeile).position : '';
    var festAufDemBild = kopfLage === 'fixed' || kopfLage === 'absolute';
    var hoehe = (kopfzeile && !festAufDemBild) ? Math.round(kopfzeile.getBoundingClientRect().height) : 0;
    /* Nicht die Kante im Fenster, sondern der Abstand vom Seitenanfang:
       getBoundingClientRect zaehlt vom Fensterrand, der Scrollstand kommt
       dazu. So steht der Wert fest, egal wo man gerade ist. */
    var oben = Math.round(feed.getBoundingClientRect().top + window.scrollY);
    if (oben < 0) oben = 0;

    if (hoehe !== gemessen.kopf) {
      gemessen.kopf = hoehe;
      feed.style.setProperty('--ml-sf-kopf', hoehe + 'px');
    }
    if (oben !== gemessen.oben) {
      gemessen.oben = oben;
      feed.style.setProperty('--ml-sf-oben', oben + 'px');
    }
  }

  function messenBald() {
    if (messWartet) return;
    messWartet = true;
    window.requestAnimationFrame(messen);
  }

  messen();
  window.addEventListener('resize', messenBald);
  window.addEventListener('orientationchange', messenBald);
  window.addEventListener('load', messenBald);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(messenBald);
  }
  if (window.ResizeObserver && kopfzeile) {
    new window.ResizeObserver(messenBald).observe(kopfzeile);
  }

  /* Die Kante, an der ein Schirm einrastet: die Kopfhoehe. Sie wird an
     zwei Stellen gebraucht, von der Skala und vom Rad. */
  function kopf() {
    if (!schirme.length) return 0;
    var m = parseFloat(getComputedStyle(schirme[0]).scrollMarginTop);
    return isNaN(m) ? 0 : m;
  }

  /* ----------------------------------------------------------------
     Die Seitenskala.

     Otton (17.09.2026): "koennen wir das sticky machen und das bewegt
     sich animiert mit dem scrollen?" und danach: "bei der animation
     will ich nicht dass dieses teil mitgeht sondern dass das naechste
     einfach laenger wird."

     Also wandert nichts. Hier wird nur die Marke gesetzt: welcher
     Strich gehoert zum Schirm an der Rastkante. Dass er laenger und
     hell wird, macht die Uebergangszeit im Stylesheet. Gewechselt wird
     nur, wenn sich der Schirm wirklich aendert — sonst liefe bei jedem
     Scrollschritt ein Stilwechsel durch zwoelf Knoten.

     Das laeuft auch, wenn jemand Bewegung abgestellt hat: der Strich
     springt dann auf seine Laenge, zeigt aber weiter an, wo man ist.
     ---------------------------------------------------------------- */
  var skala = feed.querySelector('[data-skala]');

  /* Der Name in der Mitte, wenn die Sektion darauf steht. Er haengt an
     derselben Rechnung wie die Skala — welcher Schirm an der Rastkante
     steht — und braucht deshalb keinen zweiten Scroll-Lauscher.

     Die 120 sind dieselben 120ms, die in `ml-shopfeed.css` an
     `.ml-sf__name` stehen. Laufen die beiden Zahlen auseinander, tauscht
     der Text sichtbar statt in der Unschaerfe. */
  var nameFeld = feed.querySelector('[data-sf-name]');
  var WECHSEL_MS = 120;
  var nennUhr = null;

  function nennen(i, sofort) {
    if (!nameFeld) return;
    var kopfEl = schirme[i] ? schirme[i].querySelector('.ml-sf__kopf') : null;
    var inhalt = kopfEl ? kopfEl.innerHTML : '';
    if (sofort) {
      nameFeld.innerHTML = inhalt;
      return;
    }
    nameFeld.classList.add('ml-sf__name--wechsel');
    if (nennUhr) window.clearTimeout(nennUhr);
    nennUhr = window.setTimeout(function () {
      nameFeld.innerHTML = inhalt;
      nameFeld.classList.remove('ml-sf__name--wechsel');
    }, WECHSEL_MS);
  }

  if ((skala || nameFeld) && schirme.length > 1) {
    var striche = skala
      ? Array.prototype.slice.call(skala.querySelectorAll('.ml-sf__strich'))
      : [];
    var warten = false;
    var zuletzt = -1;

    var fuehreSkala = function () {
      warten = false;

      var r = feed.getBoundingClientRect();
      var h = window.innerHeight;
      /* Sichtbar nur, solange der Feed die Sicht traegt. Ein halber
         Schirm Toleranz, damit sie an den Kanten nicht flackert. */
      var da = r.top < h * 0.5 && r.bottom > h * 0.5;
      if (skala) skala.classList.toggle('ml-sf__skala--da', da);
      if (nameFeld) nameFeld.classList.toggle('ml-sf__name--da', da);
      if (!da) return;

      /* Welcher Schirm steht an der Rastkante? Der mit dem kleinsten
         Abstand dazu — dasselbe Mass, nach dem auch das Rad faehrt. */
      var ziel = kopf();
      var hier = 0;
      var abstand = Infinity;
      for (var i = 0; i < schirme.length; i++) {
        var d = Math.abs(schirme[i].getBoundingClientRect().top - ziel);
        if (d < abstand) { abstand = d; hier = i; }
      }

      if (hier === zuletzt) return;
      /* Beim allerersten Lauf steht noch nichts da — dann wird nicht
         gewechselt, sondern gesetzt. Sonst blitzte der Name beim Laden
         der Seite einmal unscharf auf. */
      var ersterLauf = zuletzt === -1;
      zuletzt = hier;
      for (var j = 0; j < striche.length; j++) {
        striche[j].classList.toggle('ml-sf__strich--hier', j === hier);
      }
      nennen(hier, ersterLauf);
    };

    var anstossen = function () {
      if (warten) return;
      warten = true;
      window.requestAnimationFrame(fuehreSkala);
    };

    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    fuehreSkala();
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (schirme.length < 2) return;

  var sperre = false;      /* waehrend der Fahrt: nichts annehmen */
  var geste = false;       /* laeuft gerade eine Rad-Geste? */
  var gesteTimer = null;
  var sperreTimer = null;

  function aktiver() {
    var ziel = kopf();
    var best = 0, abstand = Infinity;
    schirme.forEach(function (s, i) {
      var d = Math.abs(s.getBoundingClientRect().top - ziel);
      if (d < abstand) { abstand = d; best = i; }
    });
    return best;
  }

  function fahre(i) {
    var y = schirme[i].getBoundingClientRect().top + window.scrollY - kopf();
    sperre = true;
    window.scrollTo({ top: Math.round(y), behavior: 'smooth' });
    clearTimeout(sperreTimer);
    sperreTimer = setTimeout(function () { sperre = false; }, 720);
  }

  /* Nachrollen vom echten Wisch unterscheiden.

     Otton am 17.09.2026: "man kann nicht scrollen nachdem man einmal
     gescrollt hat auf macbook mit trackpad. mit maus geht am imac."

     Vorher galt als eine Geste, was dichter als 180 ms aufeinander
     folgt. Ein Trackpad schickt nach dem Wisch aber sekundenlang
     Nachrollen-Ereignisse in genau diesem Takt: der Timer wurde endlos
     verlaengert, die Geste endete nie, der Feed stand. Eine Maus rastet
     in einzelnen Stufen und erreicht die Luecke immer — deshalb lief es
     am iMac.

     Die Zeit ist also das falsche Mass. Das richtige ist die Staerke:
     Nachrollen klingt ab, seine Betraege werden von Ereignis zu
     Ereignis kleiner. Vier fallende Werte in Folge heissen Nachrollen,
     und solange das laeuft, wird geschluckt. Wer neu wischt, schickt
     sofort wieder einen groesseren Betrag — damit ist die Kette
     gebrochen und die naechste Fahrt frei. */
  var betraege = [];

  function nachrollen(d) {
    betraege.push(d);
    if (betraege.length > 5) betraege.shift();
    if (betraege.length < 4) return false;
    for (var i = 1; i < betraege.length; i++) {
      if (betraege[i] > betraege[i - 1]) return false;
    }
    return true;
  }

  function armGeste() {
    geste = true;
    clearTimeout(gesteTimer);
    gesteTimer = setTimeout(function () { geste = false; betraege.length = 0; }, 180);
  }

  window.addEventListener('wheel', function (e) {
    if (e.ctrlKey) return; /* Zoom-Geste */
    var r = feed.getBoundingClientRect();
    var h = window.innerHeight;
    /* Nur solange der Feed die Sicht fuellt. */
    if (r.top > kopf() + 1 || r.bottom < h - 1) return;

    var runter = e.deltaY > 0;
    var i = aktiver();
    var letztes = i >= schirme.length - 1;
    var erstes = i <= 0;

    /* Am Rand nativ weiter: zur Fusszeile bzw. zum Seitenanfang. */
    if ((runter && letztes && r.bottom <= h + 1) || (!runter && erstes)) return;

    e.preventDefault();

    var staerke = Math.abs(e.deltaY);
    if (staerke < 4) return;

    /* Nachrollen derselben Geste: schlucken. Ein neuer Schub bricht die
       Kette der fallenden Betraege von selbst und kommt durch — die
       Liste wird dabei NICHT geleert, sonst faengt die Kette wieder bei
       null an und das Nachrollen rutscht durch, sobald die Sperre faellt. */
    if (geste && nachrollen(staerke)) { armGeste(); return; }
    armGeste();
    if (sperre) return;

    fahre(runter ? i + 1 : i - 1);
  }, { passive: false });
})();
